import { FunctionType } from '@/function';
import DataFactory from '../function/DataFactory';

export default class FunctionWrapper {
    public wrap(fun: (args: any) => void, type: FunctionType) {
        if (type === 'form') {
            return this.wrapForm(fun);
        } else {
            return fun;
        }
    }

    private wrapForm(fun: (args: any) => void) {
        return (args: any) => {
            const dataService = args.form.dataService;
            const factory = new DataFactory(dataService.schema);

            const data = factory.create(dataService.data, args.form.define.form.archive.tableId);

            fun({ ...args, data });
        };
    }
}
